import { Component, OnInit, OnDestroy, NgModule, Input, ViewChild, inject, computed, signal } from '@angular/core';
import { DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';
import { DxDrawerModule, DxDrawerTypes } from 'devextreme-angular/ui/drawer';
import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';
import { CommonModule } from '@angular/common';

import { Router, RouterModule, NavigationEnd, Event, RouterOutlet } from '@angular/router';
import { ScreenService, AppInfoService, AuthService } from '../../services';

import { Subscription } from 'rxjs';
import { AppHeaderComponent } from '../../components/library/app-header/app-header.component';
import { SideNavigationMenuComponent } from '../../components/library/side-navigation-menu/side-navigation-menu.component';
import { AppFooterComponent } from '../../components/library/app-footer/app-footer.component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-side-nav-outer-toolbar',
    templateUrl: './side-nav-outer-toolbar.component.html',
    styleUrls: ['./side-nav-outer-toolbar.component.scss'],
    imports: [AppHeaderComponent, DxDrawerModule, SideNavigationMenuComponent, AppFooterComponent, RouterOutlet]
})
export class SideNavOuterToolbarComponent implements OnInit, OnDestroy {
  @ViewChild(DxScrollViewComponent, { static: true }) scrollView!: DxScrollViewComponent;

  @Input()
  title!: string;

  private screen: ScreenService = inject(ScreenService);
  private authService = inject(AuthService);
  private router: Router = inject(Router);
  public appInfo: AppInfoService = inject(AppInfoService);

  selectedRoute = signal('');

  menuOpened!: boolean;
  temporaryMenuOpened = false;
  menuMode: DxDrawerTypes.OpenedStateMode = 'shrink';
  menuRevealMode: DxDrawerTypes.RevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;
  routerSubscription: Subscription;
  screenSubscription: Subscription;
  showMenu = this.authService.showMenu();

  constructor() {
    this.routerSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.selectedRoute.set(event.urlAfterRedirects.split('?')[0]);
      }
    });
  }

  ngOnInit() {
    this.menuOpened = this.showMenu && this.screen.sizes['screen-large'];
    this.screenSubscription = this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    this.screenSubscription.unsubscribe();
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall || !this.showMenu ? 0 : 48;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event: DxTreeViewTypes.ItemClickEvent) {
    const path = (event.itemData as any).path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      this.router.navigate([path]);
      // if (event.node?.selected) {
      //   pointerEvent?.preventDefault();
      // } else {
      //   this.router.navigate([path]);
      // }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent?.stopPropagation();
      }
    } else {
      pointerEvent?.preventDefault();
    }
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }
}
